module.exports = __webpack_public_path__ + "static/media/159-cambodia.25d97d74.svg";